import Axios from "axios";

export const axiosTermoUso = Axios.create({
    baseURL: process.env.REACT_APP_TERMO_API_URL,
    headers: {
      "Content-Type": "application/json",
    },
    crossdomain: true,
    withCredentials: true,
})

axiosTermoUso.interceptors.request.use((config) => {
    try
    {
        const token = sessionStorage.getItem("eRecuperadorJwt");
        if (token) {
            config.headers.Authorization = `Bearer ${token}`;
        }
    }
    catch{}

    return config;
})